import React, { useState } from 'react';
import { Button, Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { formatDateTime, formatLeadSource } from '../../../../utils/functions';
import CommonTable from '../../../global/table';
import CommonCardView from '../../../global/cardView';
import NoRecordFound from '../../../global/noRecordFound';
import CommonDrawer from '../../../global/drawer';
import EnhancedHotLeadsCardView from './EnhancedHotLeadsCardView';
import EnhancedHotLeadsDetails from './EnhancedHotLeadsDetails';

const EnhancedHotLeadsList = ({
    isLoading,
    hotLeads,
    sort,
    setSort,
    viewType,
    keyParams
}) => {
    const [leadDetails, setLeadDetails] = useState({
        show: false,
        data: null
    });

    console.log(hotLeads)

    // Columns Configuration
    const columns = [
        {
            title: "Name",
            dataIndex: "name",
            key: "name",
            sortType: "Name",
            isAvatar: true,
            render: (text, record) => (
                <div
                    className="cursor-pointer hover:text-primary font-medium"
                    onClick={() => setLeadDetails({ show: true, data: record.originalData })}
                >
                    {text}
                </div>
            )
        },
        {
            title: "Lead Source",
            dataIndex: "leadSource",
            key: "leadSource",
            sortType: "Lead Source",
            render: (text) => <span className="capitalize">{text}</span>
        },
        {
            title: "Email",
            dataIndex: "email",
            key: "email",
            sortType: "Email",
            render: (text) => (
                <p className='text-primary'>{text}</p>
            )
        },
        {
            title: "Phone",
            dataIndex: "phone",
            key: "phone",
            sortType: "Phone",
        },
        {
            title: "Event Name",
            dataIndex: "eventName",
            key: "eventName",
            sortType: "Event Name",
        },
        {
            title: "Imported At",
            dataIndex: "importedAt",
            key: "importedAt",
            sortType: "Imported At",
        }
    ];

    // Data Mapping
    const data = Array.isArray(hotLeads) && hotLeads.length > 0
        ? hotLeads.map((item) => ({
            ...item,
            key: item._id,
            id: item._id,
            leadSource: formatLeadSource(item?.leadSource),
            name: item.fullName ? item.fullName : `${item?.firstName} ${item?.lastName}`,
            email: item?.email,
            phone: item?.phone,
            eventName: item?.eventName,
            importedAt: formatDateTime(item?.dateAsPerUserTimezone),
            originalData: { ...item }
        }))
        : [];


    return (
        <>
            {data.length > 0 ? (
                <>
                    {viewType === "LIST" ? (
                        <CommonTable
                            columns={columns}
                            data={data}
                            sort={sort}
                            setSort={setSort}
                            onRowClick={(record) => setLeadDetails({ show: true, data: record.originalData })}
                            isLoading={isLoading}
                        />
                    ) : (
                        <CommonCardView>
                            {data.map((record) => (
                                <EnhancedHotLeadsCardView
                                    key={record.id}
                                    record={record}
                                    onCardClick={(record) => setLeadDetails({ show: true, data: record.originalData })}
                                />
                            ))}
                        </CommonCardView>
                    )}
                </>
            ) : (
                <NoRecordFound message="No hot leads found." />
            )}

            {
                leadDetails.show && (
                    <CommonDrawer
                        open={leadDetails.show}
                        setOpen={() => setLeadDetails({ show: false, data: null })}
                        title="Hot Lead Details"
                        width={"800px"}
                        children={
                            <EnhancedHotLeadsDetails
                                leadDetail={leadDetails.data}
                                handleClose={() => setLeadDetails({ show: false, data: null })}
                                keyParams={keyParams}
                            />
                        }
                    />
                )
            }
        </>
    );
};

export default EnhancedHotLeadsList;
